// @flow

export function identity<T> (x: T): T {
  return x
}

export function returnSecondArg<T1, T2> (_: T1, secondArg: T2): T2 {
  return secondArg
}
